import { Ort, Standort, Wegpunkt } from '../models'
import {
  BahnhofDto,
  KilometrierungDto,
  SignalDto,
  StandortDto,
  StreckeDto,
  WeicheDto
} from '../dtos'

export function convertStandortToDto(standort: Standort): StandortDto {
  let ortDto: BahnhofDto | StreckeDto
  let wegpunktDto: KilometrierungDto | SignalDto | WeicheDto

  switch (standort.ort) {
    case Ort.Bahnhof:
      if (!standort.gleis || !standort.betriebsstelle) {
        // falls dieser Fehler auftritt, wurde etwas nicht in der Formular Validierung geprüft
        throw new Error(
          `Konvertierung Standort zu StandortDto nicht möglich: eines der Felder "gleis", "betriebsstelle" ist unerwartet leer.`
        )
      }
      ortDto = {
        typ: Ort.Bahnhof,
        gleis: standort.gleis,
        betriebsstelle: standort.betriebsstelle
      } as BahnhofDto
      break

    case Ort.Strecke:
      if (!standort.von || !standort.nach || !standort.gleisart) {
        // falls dieser Fehler auftritt, wurde etwas nicht in der Formular Validierung geprüft
        throw new Error(
          `Konvertierung Standort zu StandortDto nicht möglich: eines der Felder "von", "nach" oder "gleisart" ist unerwartet leer.`
        )
      }
      ortDto = {
        typ: Ort.Strecke,
        von: standort.von,
        nach: standort.nach,
        gleisart: standort.gleisart
      } as StreckeDto
      break

    default:
      throw new Error(
        `Konvertierung Standort zu StandortDto nicht möglich: unbekannter Ort "${standort.ort}"`
      )
  }

  switch (standort.wegpunkt) {
    case Wegpunkt.Kilometrierung:
      if (!standort.kilometrierung) {
        // falls dieser Fehler auftritt, wurde etwas nicht in der Formular Validierung geprüft
        throw new Error(
          `Konvertierung Standort zu StandortDto nicht möglich: das Feld "kilometrierung" ist unerwartet leer.`
        )
      }
      wegpunktDto = {
        typ: Wegpunkt.Kilometrierung,
        kilometrierung: standort.kilometrierung
      } satisfies KilometrierungDto
      break

    case Wegpunkt.Signal:
      if (!standort.signal) {
        // falls dieser Fehler auftritt, wurde etwas nicht in der Formular Validierung geprüft
        throw new Error(
          `Konvertierung Standort zu StandortDto nicht möglich: das Feld "signal" ist unerwartet leer.`
        )
      }
      wegpunktDto = {
        typ: Wegpunkt.Signal,
        signal: standort.signal
      } as SignalDto
      break

    case Wegpunkt.Weiche:
      if (!standort.weiche) {
        // falls dieser Fehler auftritt, wurde etwas nicht in der Formular Validierung geprüft
        throw new Error(
          `Konvertierung Standort zu StandortDto nicht möglich: das Feld "weiche" ist unerwartet leer.`
        )
      }
      wegpunktDto = {
        typ: Wegpunkt.Weiche,
        weiche: standort.weiche
      } as WeicheDto
      break

    default:
      throw new Error(
        `Konvertierung Standort zu StandortDto nicht möglich: unerwarteter Standort Wegpunkt "${standort.wegpunkt}"`
      )
  }

  return {
    ort: ortDto,
    wegpunkt: wegpunktDto
  }
}

export function convertStandortDtoToModel(dto: StandortDto): Standort {
  return {
    wegpunkt: dto.wegpunkt.typ,
    ort: dto.ort.typ,
    gleisart: dto.ort.typ === Ort.Strecke ? dto.ort.gleisart : null,
    von: dto.ort.typ === Ort.Strecke ? dto.ort.von : null,
    nach: dto.ort.typ === Ort.Strecke ? dto.ort.nach : null,
    gleis: dto.ort.typ === Ort.Bahnhof ? dto.ort.gleis : null,
    betriebsstelle: dto.ort.typ === Ort.Bahnhof ? dto.ort.betriebsstelle : null,
    kilometrierung:
      dto.wegpunkt.typ === Wegpunkt.Kilometrierung
        ? dto.wegpunkt.kilometrierung
        : null,
    weiche: dto.wegpunkt.typ === Wegpunkt.Weiche ? dto.wegpunkt.weiche : null,
    signal: dto.wegpunkt.typ === Wegpunkt.Signal ? dto.wegpunkt.signal : null
  }
}
